export function Divider() {
    return (
        <svg
            className="Breadcrumbs-divider"
            width="14"
            height="23"
            viewBox="0 0 14 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
        >
            <line
                x1="13.0968"
                y1="0.162506"
                x2="0.276304"
                y2="21.9574"
                stroke="black"
                strokeWidth="0.641026"
            />
        </svg>
    );
}

export default Divider;
